import React, { Component } from 'react';
import { Mainmenu } from './Mainmenu';
import $ from 'jquery';
import './../../src/assets/js/menuCustom.js';
import logoBewise from './../assets/images/bewise-logo-new.png';
import pointer from './../assets/icons/pointer2.png';
import { Modal, ModalBody, Row, Col } from 'reactstrap';
import { BASE_URL } from '../constant';
import {
  LocationData, verifyEmail
} from '../API/FetchCall';

import { HeadsearchNew } from './head_search_new';
import { RightMenu } from './Login_pop';

import { Helmet } from 'react-helmet';

const scrollToVerticals = () => {
  window.scrollTo({
    top: 355,
    behavior: 'smooth'
    /* you can also use 'auto' behaviour 
       in place of 'smooth' */
  });
};


class NewHeader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      logged_name: '',
      authe: false,
      showModalSignup: false,
      showModalLogin: false,
      showLocationPop: false,
      sidemenu: false,
      current_location: localStorage.getItem("current_location") ? localStorage.getItem("current_location") : 'bengaluru',
    };
  }

  componentDidMount() {

    var cur_page = '/signin' + window.location.pathname;
    var This = this;
    this.LocationDataList();
    let qrystr = window.location.search;
    const urlParams = new URLSearchParams(qrystr);
    let tokenV = urlParams.get('token');
    let user_idV = urlParams.get('id');

    if (tokenV && user_idV) {
      let vdata = JSON.stringify({
        token: tokenV,
        user_id: user_idV
      })
      verifyEmail(vdata).then((response) => {
        let toastr = '';
        if (response.status == 1) {
          toastr = window.toastr.success;
          toastr(response.message, toastr, {
            positionClass: "toast-bottom-center",
            containerId: "toast-bottom-center"
          });
          window.location.href = '/';
        } else {
          let er = response.message
          toastr = window.toastr.error; //warning
          toastr(er, toastr, {
            positionClass: "toast-bottom-center",
            containerId: "toast-bottom-center"
          });
          window.location.href = '/';
        }
      });
    }
    let auth = localStorage.getItem("logged_auth");
    let data_auth = (localStorage.getItem("myData"));
    if (data_auth) {
      let auth_data = JSON.parse(data_auth);
      let login_type_name = '';
      if (auth_data.login_type == 2) {
        login_type_name = 'Google';
      } else if (auth_data.login_type == 3) {
        login_type_name = 'Facebook';
      } else if (auth_data.login_type == 4) {
        login_type_name = 'LinkedIn';
      }
      this.setState({
        logged_name: auth_data.first_name + ' ' + auth_data.last_name,
        authe: true,
        user_id: auth_data.user_id,
        login_type: auth_data.login_type,
        login_type_name: login_type_name
      });
    }
  }


  LocationDataList = async () => {
    try {
      const res = await LocationData();
      if (res.status == 1) {
        this.setState({
          location_list: res.results,
          error: false
        });
      }

    } catch (error) {
      this.setState({ error: true });
    }
  };

  locationPop = (e) => {
    this.setState({ showLocationPop: false });
  };

  handlechange_location = (e) => {
    // alert(e.target.value)
    let current_location = e.target.value;
    if (current_location != 'Bengaluru' && current_location != 'Chennai' && current_location != 'Hosur'){
      this.setState({
        showLocationPop: true
      })
    } else {
      this.setState({
        current_location: e.target.value,
        current_locations: e.target.value,
      });
      let check_location = this.state.location_list.filter(o => o.location == current_location);
      localStorage.setItem("current_location", current_location);
      let lat = check_location[0].latitude;
      let lng = check_location[0].longitude;
      localStorage.setItem("latitude", lat);
      localStorage.setItem("longitude", lng);
      window.location.reload();
    }

  }

  locationList(location_select = '') {
    let locate = this.state.location_list !== undefined ? this.state.location_list : [];

    let selected_name = '';
    if (location_select && this.state.location_list.length > 0) {
      selected_name = this.state.location_list.filter(o => o.location == location_select);
      if (selected_name.length > 0) {
        selected_name = selected_name ? selected_name[0]['location'] : '';
      }
    }

    let rows = "";
    if (locate.length > 0) {
      rows = locate.map((locate, index) => {
        let select = (selected_name == locate.location) ? 'selected' : '';
        return (
          <option key={index} value={locate.location} selected={select} >{locate.location}</option>
        );
      });

    } else {
      rows = "";
    }
    return rows;
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.login === true) {
      this.setState({
        showModalLogin: true,
        showModalSignup: false,
      })
    } else if (nextProps.signup === true) {
      this.setState({
        showModalSignup: true,
        showModalLogin: false,
      })
    }
  }
  openSingin = (e) => {
    this.setState({
      showModalLogin: true
    })
  }
  openSiemenu = (e) => {
    this.setState({
      sidemenu: true
    })
  }
  render() {

    const pageUrl = window.location.href;
    
    return (
      <React.Fragment>

         <Helmet>
             <link rel="canonical" href={pageUrl} />
        </Helmet>

        <header style={{
          position: "sticky",
          zIndex: "999",
          background: "#fff",
          width: "100%",
          top: 0
        }} className="desktop">

          <div className='tranparent-header-custom-inner'>
            <div className='container-fluid'>
              <div className='row align-items-center header-custom stickymenu sticky-top'>
                <div className='col-lg-2 col-md-6 col-xs-6 bewise-logo-block'>
                  <div className='bewise-logo active'>
                    <div class="row">
                      <div>
                        <a className='logo-text' href='/'>
                          <img src={logoBewise} alt="bewiselogo" className="mainlogoimg" style={{ width: "55px", marginRight: "2px" }} />
                        </a>
                      </div>
                      <div className="mainlogotext">
                        <h5 style={{ lineHeight: "3px", marginTop: "10px", fontWeight: "bold", transform: "scale(1, 1.1)" }}>BeWise</h5>
                        <p className="logoslogan" style={{ fontSize: "8px", fontWeight: "bold", transform: "scale(.75, 1)" }}>Enabling Learning & Fun</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='col-lg-8 col-md-8 col-xs-8 text-center'>
                  <div className="topmainsearch mainsearcharea s003 wrapper">
                    <form>
                      <div class="inner-form">
                        <div class="input-field left-wrap">
                          <img src={pointer} className="pointericon" />
                        </div>
                        <div class="input-field first-wrap">
                          <div class="cityselect input-select">

                            <select data-trigger="" value={this.state.current_location} name="choices-single-defaul" onChange={this.handlechange_location}>
                              <option placeholder="" className="select-items">Select a city</option>
                              {this.locationList()}
                            </select>
                          </div>
                        </div>
                        <div class="input-field second-wrap">
                          {/* <input id="search" type="text" placeholder="Search for a school or an after school activity" /> */}
                          <HeadsearchNew />
                        </div>
                        <div class="input-field third-wrap">
                          <button class="btn-search" type="button">
                            <svg class="svg-inline--fa fa-search fa-w-16" aria-hidden="true" data-prefix="fas" data-icon="search" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                              <path fill="currentColor" d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"></path>
                            </svg>
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                <div className='col-lg-2 col-md-6 col-xs-6 text-right bewise-signin-block'>
                  {(this.state.authe === false) ?
                    <a href="javascript:;" onClick={this.openSingin} className="nsignbtn">Sign In</a>
                    :
                    // <div onClick={this.openSiemenu}>
                    //   <span className="signned-name">{this.state.logged_name}</span>&nbsp;
                    //   <i className="fa fa-bars" aria-hidden="true"></i>
                    // </div>
                    <button className="sidebar-btn signin-name" onClick={() => this.openSiemenu()}>
                      <span className="signned-name">{this.state.logged_name}</span> <i className="fa fa-bars" aria-hidden="true"></i>  </button>
                  }
                </div>
                <RightMenu sidemenu={this.state.sidemenu} />
              </div>

            </div>
          </div>
        </header>
        <div className='d-md-none mobile'>
          <div className='tranparent-header-custom-inner'>
            <div className='container-fluid mobile-header'>
              <div className='row align-items-center header-custom'>
                <div className='col-md-6'>
                  <div className='bewise-logo active'>
                    <div class="row">
                      <div>
                        <a className='logo-text' href='/'>
                          <img src={logoBewise} style={{ width: "55px", marginRight: "2px" }} />
                        </a>
                      </div>
                      <div>
                        <h5 style={{ lineHeight: "3px", marginTop: "10px", fontWeight: "bold", transform: "scale(1, 1.1)" }}>BeWise</h5>
                        <p style={{ fontSize: "8px", fontWeight: "bold", transform: "scale(.75, 1)", marginLeft: "-10px" }}>Enabling Learning & Fun</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-md-6 text-right mobile-position bewise-signin-block'>
                  <a href="" className="nsignbtn">Sign In</a>
                </div>
              </div>
              <div className='row'>
                <div className='col-md-12 text-center'>
                  <div className="tomsearchmob s003 wrapper">
                    <form>
                      <div class="inner-form"><div className='nav-search-fill'>
                        <form
                          name='search_form'
                          id='search_form'
                          method='POST'
                          action='search'
                        >
                          <div className='search-category'>
                            <select className='nav-custom-select'
                              value={this.state.current_location} name="current_location"
                              onChange={this.handlechange_location}
                            >
                              {this.locationList()}

                            </select>
                          </div>
                          <HeadsearchNew />

                        </form>
                      </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal isOpen={this.state.showLocationPop} centered size='lg'>
          <ModalBody className='p-0'>
            <button
              className='close-btn'
              data-dismiss='modal'
              aria-label='Close'
              onClick={this.locationPop}
            >
              <img src={BASE_URL + 'assets/icons/close.svg'} alt='close' />
            </button>
            <div className=''>
              <Row className='m-5 text-center'>
                <Col sm={{ size: 12 }} className=''>
                  <div className=''>
                    <h4>Coming soon to your city. Stay tuned!</h4>
                  </div>
                </Col>
              </Row>
            </div>
          </ModalBody>
        </Modal>
        {/* <LoginPop login={this.state.showModalLogin} signup={this.state.showModalSignup} /> */}
      </React.Fragment >
    );
  }
}

export default NewHeader;

